import { useId } from "react";

/**
 * La marca de Keellabs, la misma que la version clasica: el arco con la punta de flecha (el rango
 * que vuelve) y la K encima.
 *
 * El degradado va en un `<defs>` con id propio. Si el logo aparece dos veces en la pantalla y las
 * dos comparten id, el navegador se queda con el primero que encuentra y el segundo puede salir
 * sin color al desmontarse el otro — por eso el id sale de `useId()` y no esta escrito a mano.
 */
export function Logo({ size = 28 }: { size?: number }) {
  const grad = `keelGrad-${useId().replace(/:/g, "")}`;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden focusable="false">
      <defs>
        <linearGradient id={grad} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2FE3C8" />
          <stop offset="1" stopColor="#9B7BFF" />
        </linearGradient>
      </defs>
      <path
        d="M23.84 6.65A12.2 12.2 0 1 0 27.06 21.16"
        stroke={`url(#${grad})`}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path d="M28.75 17.53 29.33 22.22 24.79 20.10Z" fill={`url(#${grad})`} />
      <path
        d="M10.37 9.4H12.99V14.42L17.76 9.4H21.28L15.65 15.47L21.54 22.6H18.02L12.99 16.53V22.6H10.37Z"
        fill={`url(#${grad})`}
      />
    </svg>
  );
}
